module.exports = __webpack_public_path__ + "img/Recurso 9@300x.12939db5.webp";